// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b31d57e5","513":"2ff26e72"}[chunkId] + ".chunk.js";
};